module.exports = __webpack_public_path__ + "img/counter-timer.20303216.svg";